import React, { useCallback, useMemo } from 'react';
import Select from 'react-select';
import classNames from 'classnames';

import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { useAnalytics } from 'util/analytics';

import {
  SortByAccommodations,
  SortByAccommodationsMap,
  SortByAccommodationsOptions,
} from './constants';
import styles from './styles.module.scss';

export interface IProps {
  sortBy: SortByAccommodations,
  setSortBy: (sortType: SortByAccommodations) => void,
  title?: string,
  className?: string,
}

export const SortAccommodations = ({
  setSortBy,
  sortBy,
  className,
  title,
}: IProps) => {
  const { t } = useOTSTranslation('common');
  const analytics = useAnalytics();

  const sortByVal = useMemo(() => ({
    value: sortBy,
    label: t(SortByAccommodationsMap[sortBy]),
  }), [sortBy]);

  const handleChangeSortAccommodation = useCallback((value: {
    value: SortByAccommodations;
    label: string;
  } | null) => {
    const arr = Array.isArray(value) ? value : [value];
    const n = arr[0];

    setSortBy(n.value);
    analytics.sortContent({ content: (n.value === SortByAccommodations.NAME) ? 'Name' : 'Highest Rated' });
  }, [setSortBy]);

  const options = useMemo(() => SortByAccommodationsOptions.map((v) => ({
    value: v.value,
    label: t(v.label),
  })), []);

  return (
    <section className={classNames(styles.box, { [styles.noHeader]: !title }, className)}>
      {title && (
        <h2>{t('resort.lodging.allHotelsHeading', { resort: title })}</h2>
      )}
      <div>
        <label htmlFor="resort.lodging.sortBy">{t('resort.lodging.sortBy')}</label>
        <Select
          id="resort.lodging.sortBy"
          isSearchable={false}
          onChange={handleChangeSortAccommodation}
          options={options}
          value={sortByVal}
        />
      </div>
    </section>
  );
};
